import { Button } from "../components/ui/button";
import { FiFilter, FiSearch } from "react-icons/fi";
import { Input } from "../components/ui/input";
import { ExpandedDataTableTreeView } from "../components/ExpandedDataTable";
import { useEffect, useState } from "react";
import { materialService } from "../services";
import { Skeleton } from "../components/ui/skeleton";
import TableCard from "../components/TableCard";
import { LucideRecycle } from "lucide-react";
import LoadingImage from "../components/LoadingImage";
import { createItemStore } from "../stores/createItemStore";

// ========================================================
// Step 1: Zustand store instantiation
// ========================================================
const dataMap = (item) => item;

const storeName = "materials";
const useItems = createItemStore(
  storeName,
  (material) => material._id,
  materialService.getMaterial,
  dataMap
);
// ========================================================

const MaterialManagement = () => {
  const [searchQuery, setSearchQuery] = useState("");

  // Table columns
  const tableColumns = [
    { header: "Category", accessorKey: "category" },
    { header: "Description", accessorKey: "description" },
    { header: "Unit", accessorKey: "unit" },
    { header: "Point", accessorKey: "point" },
  ];

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================
  const { isLoading, fetchItems, getSortedFiltered } = useItems(
    (state) => state
  );
  const data = getSortedFiltered();
  const formattedData = materialService.getTreeData(data);
  // console.log(`formattedData:`, formattedData);

  const showLoading = data.length === 0 && isLoading;
  useEffect(() => {
    fetchItems();
  }, []);
  // ========================================================

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 p-4 sm:p-8">
          <div className="bg-white shadow rounded-lg p-4 sm:p-6 text-sm overflow-x-auto">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center mb-4">
              <div className="text-base sm:text-lg font-semibold text-[#111827] mb-4 sm:mb-0">
                Material List
              </div>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center mb-4">
              <div className="relative w-full sm:w-[24rem]">
                <Input
                  type="text"
                  placeholder="Search by material name, description, unit or points..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <FiSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
              </div>
              <div className="flex items-center space-x-4">
                {searchQuery && (
                  <Button
                    variant="ghost"
                    onClick={() => setSearchQuery("")}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    Clear
                  </Button>
                )}
                <Button variant={"secondary"}>
                  <FiFilter className="mr-2" /> Filters
                </Button>
              </div>
            </div>

            {showLoading ? (
              // {loading ? (
              <LoadingImage />
            ) : data.length > 0 ? (
              // ) : treeMenuData.length > 0 ? (
              <ExpandedDataTableTreeView
                treeMenuData={formattedData}
                tableColumns={tableColumns}
                searchQuery={searchQuery}
              />
            ) : (
              <div className="text-center text-gray-500 py-6">
                No requests found.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialManagement;
